let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lLAhl")).then(() => parcelRequire('9KFoy'));